/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGuardianDto } from '../../models/create-guardian-dto';
import { GuardianDto } from '../../models/guardian-dto';

export interface UserGuardianControllerManualCreate$Params {
  childId: string;
  centerId: string;
      body: CreateGuardianDto
}

export function userGuardianControllerManualCreate(http: HttpClient, rootUrl: string, params: UserGuardianControllerManualCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GuardianDto>> {
  const rb = new RequestBuilder(rootUrl, userGuardianControllerManualCreate.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GuardianDto>;
    })
  );
}

userGuardianControllerManualCreate.PATH = '/api/guardian/user/manual';
